/// <reference types="vite-plus/client" />
import { z } from "zod";

const API = "api";

const envSchema = z.object({
  VITE_APP_CLIENT_ENV: z.string().prefault("local"),
  VITE_APP_SERVER_BASE_URL: z.string().optional(),
  VITE_APP_NODE_ENV: z.string().prefault("local")
});

const formatBaseUrl = (protocol: string, hostname: string, port?: number) => {
  return protocol + "//" + hostname + (port ? ":" + port : "");
};

export const env = envSchema.parse(import.meta.env);

const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname.endsWith(".trycloudflare.com");

const inferred = (() => {
  const hostnameParts = window.location.hostname.split(".");
  let mode = "admin";
  const matched = hostnameParts[0].match(/^(?<env>[^-]+)-(?<mode>[^-]+)$/);
  if (matched && matched?.groups) {
    mode = matched.groups.mode;
    hostnameParts[0] = `${matched.groups.env}-${API}`;
  } else if (hostnameParts.length > 2) {
    mode = hostnameParts[0].toLowerCase();
    hostnameParts[0] = API;
  } else {
    hostnameParts.unshift(API);
  }
  const serverHost = hostnameParts.join(".");
  return { mode, serverHost };
})();

const isTunnel = isLocal && window.location.hostname !== "localhost";

export const SERVER_BASE_URL =
  env.VITE_APP_SERVER_BASE_URL ||
  (isTunnel
    ? "/api"
    : isLocal
      ? formatBaseUrl(window.location.protocol, "localhost", 8000)
      : formatBaseUrl(window.location.protocol, inferred.serverHost));

export const CLIENT_BASE_URL = formatBaseUrl(
  window.location.protocol,
  window.location.hostname,
  window.location.port ? parseInt(window.location.port) : undefined
);

export const GOOGLE_CLIENT_ID =
  "874354046897-fngq8nee4s9aula5l8bap7cgbqvp8n8f.apps.googleusercontent.com";

export const createAdminUrl = () =>
  CLIENT_BASE_URL === "https://agenda.swivu.com"
    ? "https://swivu.com"
    : CLIENT_BASE_URL.replace("agenda", "admin");

export const createAgendaUrl = () =>
  CLIENT_BASE_URL === "https://swivu.com"
    ? "https://agenda.swivu.com"
    : CLIENT_BASE_URL.replace("admin", "agenda");
